<template>
  <div>
    <app-spinner v-if="!page_loaded"/>
    <template v-else>
      <h1 class="title">Properties</h1>
      <app-cells>
        <app-button @click.native="onShowModal">Create</app-button>
      </app-cells>
      <table-properties
        :table-items="table_items"
      />
    </template>
    <modal
      name="create-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('create-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Create property</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Name" label-for="name" required>
              <app-input
                v-model="form.name"
                id="name"
                placeholder="Name"
                name="name"
                :error="$v.form.name.$error"
              />
              <template #error>
                <div v-if="$v.form.name.$dirty && !$v.form.name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Required insurances">
              <app-select
                v-model="form.required_insurances"
                :options="insurances_options"
                :reduce="item => item.id"
                :closeOnSelect="false"
                placeholder="Required insurances"
                multiple
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submit" :disabled="$v.form.$error">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getAdministrativeInsuranceTypes, getAdministrativeProperties, postAdministrativeProperties } from '@/http'
import { required } from 'vuelidate/lib/validators'
import TableProperties from '@/views/administrative/properties/tables/TableProperties.vue'

export default {
  name: 'AdministrativePropertiesList',
  components: {TableProperties},
  data() {
    return {
      page_loaded: false,
      table_items: [],
      insurances_options: [],
      form: {},
    }
  },
  validations: {
    form: {
      name: {required},
    }
  },
  created() {
    this.fetchItems()
    getAdministrativeInsuranceTypes().then(response => {
      this.insurances_options = response.data
    })
  },
  methods: {
    fetchItems() {
      getAdministrativeProperties()
        .then(response => {
          this.table_items = response.data
          this.page_loaded = true
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      postAdministrativeProperties(this.form)
        .then(() => {
          this.fetchItems()
          this.$modal.hide('create-modal')
        })
        .catch(() => {
          this.$refs.submit.preload = false
        })
    },
    onShowModal() {
      this.form = {}
      this.$v.form.$reset()
      this.$modal.show('create-modal')
    },
  }
}
</script>
